<ng-container *ngIf="resumeloading == false">
  <div class="container text-center">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
  </div>
</ng-container>
<ng-container *ngIf="resumeloading">
  <div class="cf-chart-grid cf-chart-grid--wide">
    <div class="cf-chart-card">
      <div class="cf-chart-card__header">
        <div class="cf-chart-card__icon cf-chart-card__icon--green">
          <mat-icon>assessment</mat-icon>
        </div>
        <div class="cf-chart-card__title-wrap">
          <p class="cf-chart-card__title">Informe sobre resultados</p>
          <p class="cf-chart-card__sub">Cuenta de resultados del periodo seleccionado</p>
        </div>
        <div class="cf-chart-card__header-actions">
          <mat-form-field subscriptSizing="dynamic" style="width:190px;">
            <mat-label>Meses</mat-label>
            <mat-select [formControl]="monthControl" multiple
              (selectionChange)="onChangeMonth($event)" #monthSelect>
              <mat-checkbox (change)='onSelectAll($event)' class="ps-3" [(ngModel)]="allMonthsSelected">
                Todos
              </mat-checkbox>
              <mat-select-trigger>
                <span *ngIf="allMonthsSelected" class="example-additional-selection">
                  Todos
                </span>
                <span *ngIf="!allMonthsSelected" class="example-additional-selection">
                  {{ getSelectedMonthsNames() }}
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let card of monthList; trackBy: trackByIndex" [value]="card.number">{{card.name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="table-responsive">
        <table class="tabla-resultados table">
          <tr>
            <th colspan="2" style="font-weight: bold;">INFORME SOBRE RESULTADOS</th>
            <th></th>
          </tr>
          <tr>
            <th>Mes/Periodo</th>
            <th>IMPORTE</th>
            <th>%</th>
          </tr>
          <tr>
            <td>Ingresos</td>
            <td>{{ summaryResult.income | currency: 'EUR':'symbol':'1.2-2':'es' }}</td>
            <td></td>
          </tr>
          <tr>
            <td>Compras</td>
            <td>{{ summaryResult.purchases | currency: 'EUR':'symbol':'1.2-2':'es' }}</td>
            <td>{{ getPositivePercentage(summaryResult.purchases, summaryResult.income) | percent:'1.0-0' }}</td>
          </tr>
          <tr style="font-weight:bold;background:#f5f5f5;">
            <td>MARGEN BRUTO</td>
            <td [style.color]="summaryResult.grossMargin >= 0 ? '#16a34a' : '#dc2626'">{{ summaryResult.grossMargin | currency: 'EUR':'symbol':'1.2-2':'es' }}</td>
            <td>{{ getPositivePercentage(summaryResult.grossMargin, summaryResult.income) | percent:'1.0-0' }}</td>
          </tr>
          <tr>
            <td>Otros Ingresos Operativos</td>
            <td>{{ summaryResult.otherOperatingIncome | currency: 'EUR':'symbol':'1.2-2':'es' }}</td>
            <td></td>
          </tr>
          <tr>
            <td>Otros gastos Operativos</td>
            <td>{{ summaryResult.otherOperatingExpenses | currency: 'EUR':'symbol':'1.2-2':'es' }}</td>
            <td>{{ getPositivePercentage(summaryResult.otherOperatingExpenses, (summaryResult.income +
              summaryResult.otherOperatingIncome)) | percent:'1.0-0' }}</td>
          </tr>
          <tr>
            <td>Gastos del personal</td>
            <td>{{ summaryResult.personnelExpenses | currency: 'EUR':'symbol':'1.2-2':'es' }}</td>
            <td>{{ getPositivePercentage(summaryResult.personnelExpenses, (summaryResult.income +
              summaryResult.otherOperatingIncome)) | percent:'1.0-0' }}</td>
          </tr>
          <tr style="font-weight:bold;background:#f5f5f5;">
            <td>EBITDA</td>
            <td [style.color]="summaryResult.ebitda >= 0 ? '#16a34a' : '#dc2626'">{{ summaryResult.ebitda | currency: 'EUR':'symbol':'1.2-2':'es' }}</td>
            <td>{{ getPositivePercentage(summaryResult.ebitda, (summaryResult.income +
              summaryResult.otherOperatingIncome)) | percent:'1.0-0' }}</td>
          </tr>
          <tr>
            <td>Depreciaciones/Amortizaciones</td>
            <td>{{ summaryResult.amortization | currency: 'EUR':'symbol':'1.2-2':'es' }}</td>
            <td>{{ getPositivePercentage(summaryResult.amortization, (summaryResult.income +
              summaryResult.otherOperatingIncome)) | percent:'1.0-0' }}</td>
          </tr>
          <tr style="font-weight:bold;background:#f5f5f5;">
            <td>Resultado operativo</td>
            <td [style.color]="summaryResult.operatingIncome >= 0 ? '#16a34a' : '#dc2626'">{{ summaryResult.operatingIncome | currency: 'EUR':'symbol':'1.2-2':'es' }}</td>
            <td>{{ getPositivePercentage(summaryResult.operatingIncome, (summaryResult.income +
              summaryResult.otherOperatingIncome)) | percent:'1.0-0' }}</td>
          </tr>
          <tr>
            <td>Resultados extraordinarios</td>
            <td>{{ summaryResult.extraordinaryResults | currency: 'EUR':'symbol':'1.2-2':'es' }}</td>
            <td>{{ getPositivePercentage(summaryResult.extraordinaryResults, (summaryResult.income +
              summaryResult.otherOperatingIncome)) | percent:'1.0-0' }}</td>
          </tr>
          <tr style="font-weight:bold;background:#f5f5f5;">
            <td>EBIT</td>
            <td [style.color]="summaryResult.ebit >= 0 ? '#16a34a' : '#dc2626'">{{ summaryResult.ebit | currency: 'EUR':'symbol':'1.2-2':'es' }}</td>
            <td>{{ getPositivePercentage(summaryResult.ebit, (summaryResult.income +
              summaryResult.otherOperatingIncome)) | percent:'1.0-0' }}</td>
          </tr>
          <tr>
            <td>Resultado Financiero</td>
            <td>{{ summaryResult.financialResult | currency: 'EUR':'symbol':'1.2-2':'es' }}</td>
            <td>{{ getPositivePercentage(summaryResult.financialResult, (summaryResult.income +
              summaryResult.otherOperatingIncome)) | percent:'1.0-0' }}</td>
          </tr>
          <tr style="font-weight:bold;background:#f5f5f5;">
            <td>B.A.I</td>
            <td [style.color]="summaryResult.profitBeforeTax >= 0 ? '#16a34a' : '#dc2626'">{{ summaryResult.profitBeforeTax | currency: 'EUR':'symbol':'1.2-2':'es' }}</td>
            <td>{{ getPositivePercentage(summaryResult.profitBeforeTax, (summaryResult.income +
              summaryResult.otherOperatingIncome)) | percent:'1.0-0' }}</td>
          </tr>
          <tr>
            <td>Impuesto sobre beneficios</td>
            <td>{{ summaryResult.incomeTax | currency: 'EUR':'symbol':'1.2-2':'es' }}</td>
            <td>{{ getPositivePercentage(summaryResult.incomeTax, (summaryResult.income +
              summaryResult.otherOperatingIncome)) | percent:'1.0-0' }}</td>
          </tr>
          <tr style="font-weight:bold;background:#f5f5f5;">
            <td>RESULTADO NETO</td>
            <td [style.color]="summaryResult.netIncome >= 0 ? '#16a34a' : '#dc2626'">{{ summaryResult.netIncome | currency: 'EUR':'symbol':'1.2-2':'es' }}</td>
            <td>{{ getPositivePercentage(summaryResult.netIncome, (summaryResult.income +
              summaryResult.otherOperatingIncome)) | percent:'1.0-0' }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</ng-container>
